<template>
  <div class="SetUserName">
    <div class="SetUserNameDesc">
      <div>{{ $locale["need_update_username_desc"] }}</div>
      <div class="UserNameFeatures">{{ $locale["username_features"] }}</div>
    </div>
    <div class="SetUsernameInput">
      <Input tcenter :placeholder="$user.user" @input="({ value }) => (username = value)" />
    </div>
    <Spacer num="1.5" />
    <div class="SetUsernameOptions">
      <a :class="`primary-button __button ${!username && '__disabled'}`" block @click="isConfirm = !isConfirm">{{ $locale["save"] }}</a>
    </div>
    <Spacer num="1" />

    <div :class="`UpdateUserConfirm`" v-if="isConfirm">
      <div class="content">
        <div dpadding tcenter>
          <div strong>{{ $locale["sure_update_username"] }}</div>
          <Spacer num=".5" />
          <div strong dcolor v-size="`130%`">{{ username }}</div>
          <Spacer num="1" />
        </div>
        <Confirm :confirm="confirm" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["modal"],
  data: function() {
    return {
      username: "",
      isConfirm: false,
    };
  },
  methods: {
    chageUserName: async function() {
      this.valid = this.$global.validUserName(this.username);

      if (!this.valid) {
        return this.alert({ title: "Error", message: this.$locale["username_features"] });
      }

      this.loading = await this.loader({ showProgress: false });

      try {
        this.req = await this.api.post("/user/updateUserName", { username: this.username });
        this.changeSuccess(this.req.data);
      } catch (error) {
        this.alert(Go.getErrorMessage(error));
      }

      this.loading.close();
    },
    changeSuccess: async function(data) {
      if (data.success) {
        this.$store.dispatch("updateUser", data);
        this.$store.dispatch("getProfile");
        this.modal.close();
      }

      return this.alert(data);
    },
  },
  computed: {
    confirm: function() {
      return {
        cancel: {
          label: this.$locale["cancel"],
          action: () => {
            this.isConfirm = false;
          },
        },
        accept: {
          label: this.$locale["confirm"],
          action: () => {
            this.chageUserName();
          },
        },
      };
    },
  },
};
</script>

<style lang="scss">
.SetUserName {
  position: relative;

  .SetUserNameDesc {
    padding: $mpadding;
    font-size: 120%;
    text-align: center;
  }

  .SetUsernameInput {
    padding: 0 $mpadding;
  }

  .SetUsernameInput .block-input input {
    text-align: center;
    font-family: $third_font_bold;
  }

  .SetUsernameOptions {
    padding: 0 $mpadding;
  }

  .SetUsernameOptions .__button {
    padding: $mpadding * 0.8 $mpadding;
  }

  .UserNameFeatures {
    font-size: 90%;
    opacity: 0.8;
    margin: $mpadding/4 0 0 0;
  }

  .UpdateUserConfirm {
    @include Absolute();
    background-color: #fff;
    @include Flex(inherit, center, center);
  }

  .UpdateUserConfirm .content {
    width: 100%;
    padding: $mpadding;
  }
}
</style>
